import React from 'react';
import { Form, Label } from 'semantic-ui-react';

const TextInput = ({
	input,
	width,
	type,
	placeholder,
	label,
	disabled,
	defaultValue,
	meta: { touched, error }
}) => {
	return (
		<Form.Field error={touched && !!error} width={width}>
			{label && <label>{label}</label>}
			<input
				{...input}
				value={input.value ? input.value : defaultValue}
				placeholder={placeholder}
				type={type}
				disabled={disabled}
			/>
			{touched && error && (
				<Label basic color="red" pointing>
					{error}
				</Label>
			)}
		</Form.Field>
	);
};

export default TextInput;
